import React from 'react';
import Link from '../../../../../../v2BaseComponents/Link';
import SkeletonLoadingContainer from '../../../../../../v2BaseComponents/SkeletonLoadingContainer';

export type BaseReferenceOwnProps = {
    onPress: () => void;
    text: string | null;
    isLoading: boolean;
};

export type BaseReferenceProps = BaseReferenceOwnProps;

const BaseReference: React.FC<BaseReferenceProps> = ({ onPress, text, isLoading }) => {
    if (!text && !isLoading) return null;

    return (
        <SkeletonLoadingContainer isLoading={isLoading}>
            <Link variant="h6" onPress={onPress} style={{ marginBottom: 8 }} testID="chat-reference-link">
                {text || 'Placeholder Text Placeholder Text Placeholder Text'}
            </Link>
        </SkeletonLoadingContainer>
    );
};

export default React.memo(BaseReference);
